export const HamburgerMenu = ({ onClick }) => {
    return (
        <nav className="navbar navbar-light">
            <button
                className="navbar-toggler border border-white"
                type="button"
                onClick={onClick}
            >
                <span className="navbar-toggler-icon"></span>
            </button>
        </nav>
    );
};
